import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

const TemplateHeaderView = ({ intl, surveyName, changeEditState }) => (
  <Row noGutters>
    <Col xs="auto">
      <h2>{surveyName}</h2>
    </Col>
    <Col>
      <Button
        variant="link"
        title={intl.formatMessage({ id: "survey.editor.title.edit" })}
        onClick={(e) => changeEditState(e)}
      >
        <FontAwesomeIcon icon={faPencilAlt} />
      </Button>
    </Col>
  </Row>
);

TemplateHeaderView.propTypes = {
  surveyName: PropTypes.string,
  changeEditState: PropTypes.func
};
export default injectIntl(TemplateHeaderView);
